import { userState } from "@/state/Users";
import { submissionState } from "@/state/Submissions";
import "@/components/annotations/annotation_options";
import "@/components/annotations/annotations_count_badge";
import {
    anyRangeInAnnotation,
    selectedRangeFromSelection,
    triggerSelectionEnd,
} from "@/components/annotations/selectionHelpers";

// Document-level glue for the code listing. The listing itself is rendered by
// d-feedback-code-tab; what remains here is the page-wide annotate-button setup
// and the line highlighting used by the feedback table for deep links.

const MARKING_CLASS = "marked";

function initAnnotateButtons(): void {
    userState.addPermission("annotation.create");

    document.addEventListener("pointerup", () => void triggerSelectionEnd());

    // make the whole document a valid target for dropping the create annotation button
    document.addEventListener("dragover", (e) => e.preventDefault());
    document.addEventListener("drop", (e) => e.preventDefault());

    // copy only the selected code, this avoids copying the line numbers or extra whitespace from the complex html
    document.addEventListener("copy", (event) => {
        const browserSelection = window.getSelection();
        if (browserSelection.isCollapsed || anyRangeInAnnotation(browserSelection)) {
            return; // selection is collapsed or contains an annotation, let the browser handle the copy event
        }

        const selection = selectedRangeFromSelection(browserSelection, true);
        if (!selection) {
            return; // if there is no code selection, let the browser handle the copy event
        }

        const selectedCode = submissionState.code
            .split("\n")
            .slice(selection.row - 1, selection.row + selection.rows - 1);
        // on the first and last line, selection might only cover part of the line
        // only copy the selected columns/characters
        selectedCode[0] = selectedCode[0].slice(selection.column);
        selectedCode[selectedCode.length - 1] = selectedCode[selectedCode.length - 1].slice(0, selection.columns);
        event.clipboardData.setData("text/plain", selectedCode.join("\n"));
        event.preventDefault();
    });
}

// /////////////////////////////////////////////////////////////////////////
// Highlighting ////////////////////////////////////////////////////////////
// /////////////////////////////////////////////////////////////////////////

function clearHighlights(): void {
    const markedAnnotations = document.querySelectorAll(`tr.lineno.${MARKING_CLASS}`);
    markedAnnotations.forEach((markedAnnotation) => {
        markedAnnotation.classList.remove(MARKING_CLASS);
    });
}

function highlightLine(lineNr: number, scrollToLine = false): void {
    const toMarkAnnotationRow = document.querySelector(`tr.lineno#line-${lineNr}`);
    toMarkAnnotationRow.classList.add(MARKING_CLASS);
    if (scrollToLine) {
        toMarkAnnotationRow.scrollIntoView({ block: "center" });
    }
}

export default {
    initAnnotateButtons,
    clearHighlights,
    highlightLine,
};
